// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Details {
  border-width: 0;
  background: transparent;
  overflow: auto;
}
.Details .card-body {
  color: var(--bs-primary);
}
.Details .card-body .row {
  flex-wrap: nowrap;
}
.Details .card-body .row > .col {
  flex-grow: 0;
  flex-shrink: 1;
  white-space: nowrap;
}
.Details .card-body .row > .col > div {
  display: flex;
  flex-direction: column;
}
.Details .card-body .row > .col > div span:first-child {
  font-size: 1rem;
  font-weight: 500;
}
.Details .card-body .row > .col > div span:last-child {
  font-size: 1.33rem;
  font-weight: 700;
}
.Details.inline .card-body .row {
  justify-content: space-between;
}
.Details.inline .card-body .row > .col > div {
  color: #000;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.Details.inline .card-body .row > .col > div span:first-child {
  font-size: 1rem;
  font-weight: 700;
}
.Details.inline .card-body .row > .col > div span:first-child::after {
  content: ":";
}
.Details.inline .card-body .row > .col > div span:last-child {
  font-size: 1rem;
  font-weight: 500;
}
.Details .gap-10 {
  gap: 10rem;
}

.ReportTable + .Details.inline .row {
  justify-content: flex-start;
}
.ReportTable + .Details.inline .row > .col:not(:first-child) {
  margin-left: 2rem;
}

@media print {
  .Details {
    width: 100% !important;
  }
  .Details:not(.inline) .card-body .row > .col {
    justify-content: end;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Details/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,uBAAA;EACA,cAAA;AACF;AAAE;EACE,wBAAA;AAEJ;AADI;EACE,iBAAA;AAGN;AAFM;EACE,YAAA;EACA,cAAA;EACA,mBAAA;AAIR;AAHQ;EACE,aAAA;EACA,sBAAA;AAKV;AAJU;EACE,eAAA;EACA,gBAAA;AAMZ;AAJU;EACE,kBAAA;EACA,gBAAA;AAMZ;AAAE;EACE,8BAAA;AAEJ;AADI;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAGN;AAFM;EACE,eAAA;EACA,gBAAA;AAIR;AAHQ;EACE,YAAA;AAKV;AAFM;EACE,eAAA;EACA,gBAAA;AAIR;AAAE;EACE,UAAA;AAEJ;;AAEE;EACE,2BAAA;AACJ;AAAI;EACE,iBAAA;AAEN;;AAEA;EACE;IACE,sBAAA;EACF;EAGQ;IACE,oBAAA;EADV;AACF","sourcesContent":[".Details {\n  border-width: 0;\n  background: transparent;\n  overflow: auto;\n  .card-body {\n    color: var(--bs-primary);\n    .row {\n      flex-wrap: nowrap;\n      > .col {\n        flex-grow: 0;\n        flex-shrink: 1;\n        white-space: nowrap;\n        > div {\n          display: flex;\n          flex-direction: column;\n          span:first-child {\n            font-size: 1rem;\n            font-weight: 500;\n          }\n          span:last-child {\n            font-size: 1.33rem;\n            font-weight: 700;\n          }\n        }\n      }\n    }\n  }\n  &.inline .card-body .row {\n    justify-content: space-between;\n    > .col > div {\n      color: #000;\n      flex-direction: row;\n      align-items: center;\n      gap: 0.5rem;\n      span:first-child {\n        font-size: 1rem;\n        font-weight: 700;\n        &::after {\n          content: ':';\n        }\n      }\n      span:last-child {\n        font-size: 1rem;\n        font-weight: 500;\n      }\n    }\n  }\n  .gap-10 {\n    gap: 10rem;\n  }\n}\n.ReportTable + .Details.inline {\n  .row {\n    justify-content: flex-start;\n    > .col:not(:first-child) {\n      margin-left: 2rem;\n    }\n  }\n}\n@media print {\n  .Details {\n    width: 100% !important;\n    &:not(.inline) {\n      .card-body {\n        .row {\n          > .col {\n            justify-content: end;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
